import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { ViewProfileService } from 'src/app/shared/services/view-profile-servies/view-profile.service';


@Component({
  selector: 'app-add-staff',
  templateUrl: './add-staff.component.html',
  styleUrls: ['./add-staff.component.css']
})
export class AddStaffComponent {
  form!: FormGroup;
  submitted = false;
  errorMessage = '';
  file: any;
  folderName = 'customer';

  personnel_id: string | null = null;
  isEditMode = false;
  imageurl: any;
  searchKeyword = '';
  states: any;
  cities: any;
  organizationId: any;
  userD: any;
  branchList:any
  branchShow= true
roles:any
//  organizations: string[] = [
  
//   'Principal/PMO',
//   'SaaS Product Owner',
//   'Contractor/Subcontractor',
//   'Other'
// ];
organizations: { id: any; value: any }[] = [
  { id: 1, value: 'Principal/PMO' },
  // { id: 2, value: 'SaaS Product Owner' },
  { id: 3, value: 'Contractor/Subcontractor' },
  { id: 4, value: 'Other' }
];


 organizationDesignations: { [key: string]: string[] } = {
  1: [
    'Project Manager',
    'Assistant Project Manager',
    'Planner',
    'Lead Civil Engineer',
    'Site Engineer',
    'Geotechnical Engineer',
    'Surveyor',
    'Construction Manager',
    'Foreman',
    'Supervisor',
    'Safety Officer',
    'Financial Controller',
    'Purchasing Manager',
    'Stores Incharge',
    'Sales Manager',
    'Business Development Officer',
    'HR Manager',
    'Accountant',
    'Cost Analyst'
  ],

  2: [
    'SaaS Product Owner',
    'Sales Manager',
    'Support Analyst',
    'Financial Analyst',
    'Developer',
    'Business Development Officer'
  ],

  3: [
    'Subcontractor Coordinator',
    'Subcontractor Project Manager',
    'Subcontractor Planner',
    'Asphalt Contractor',
    'Concrete Contractor',
    'Surveyor',
    'Supervisor',
    'Worker',
    'Mason',
    'Helper',
    'Equipment Manager',
    'Driver',
    'Subcontractor Purchasing Agent',
    'Subcontractor Stores Incharge',
    'Subcontractor Sales Representative',
    'Subcontractor Accountant',
    'Payroll Specialist',
    'Subcontractor Site Supervisor',
    'Subcontractor Worker',
    'Subcontractor Mason',
    'Subcontractor Helper',
    'Subcontractor Surveyor',
    'Subcontractor Equipment Operator',
    'Subcontractor Logistics Coordinator',
    'Subcontractor Accountant',
    'Subcontractor Billing Clerk'
  ],

  4: [
    'Community Liaison Officer',
    'Regulatory Financial Auditor',
    'Government Inspector',
    'Environmental Consultant'
  ]
};
designationList: string[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private profileService: ViewProfileService,
    private toastrMsgService: ToastrMsgService,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
  ) { }

  ngOnInit(): void {
     const user = localStorage.getItem('user') as any;
    this.userD = JSON.parse(user);
    this.organizationId=this.userD.user.org_id;
    this.fetchBranchList()
    this.form = this.formBuilder.group({
      branch_id: [+this.organizationId],
      full_name: ['', Validators.required],
      specialization: [''],
      contact_phone: ['', Validators.required],
      department: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      postalCode: ['', Validators.required],
      isActive: [1],
      roleId: ['', Validators.required],
      domain: ['', ],
      address: ['', Validators.required],
      contact_email: [''],
      emailId: ['', [Validators.required, Validators.email]],

      employeeNumber: ['', Validators.required],
      image: [''],
      emergencyContact: this.formBuilder.group({
        name: ['', Validators.required],
        mobile: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
        email: ['', [Validators.required, Validators.email]]
      }),
      employmentStartDate: ['', Validators.required],
      designation: ['', Validators.required],
      roleInSoftware: ['', Validators.required],
      membershipStartDate: [''],
      membershipEndDate: [''],
      employeeId: [''],
    });

    this.personnel_id = this.route.snapshot.paramMap.get('id');
    if (this.personnel_id) {
      this.isEditMode = true;
      this.fetchStaff();
    }
    this.onCountryChange();
    this.fetchDataRole();
  }
  fetchBranchList() {
    this.apiService.getOrganizationsBranch( this.organizationId).subscribe({
      next: (res: any) => {
        const branches = res?.data || [];
        this.branchList = branches;
        this.syncBranchRequirement(branches.length > 0);
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.message);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  private syncBranchRequirement(hasBranches: boolean): void {
    this.branchShow = hasBranches;
    const control = this.form?.get('branch_id');
    if (!control) {
      return;
    }
    if (hasBranches) {
      control.setValidators(Validators.required);
    } else {
      control.clearValidators();
      if (control.value == null || control.value === '') {
        control.setValue(this.organizationId);
      }
    }
    control.updateValueAndValidity({ emitEvent: false });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  handleFileInput(event: any) {
    const file = event.target.files?.[0];
    if (!file) {
      this.errorMessage = 'No file chosen.';
      return;
    }

    const fileSize = file.size / 1024 / 1024;
    const fileType = file.type;

    if (!['image/jpeg', 'image/png'].includes(fileType)) {
      this.errorMessage = 'File should be JPEG or PNG.';
      return;
    }

    if (fileSize > 3) {
      this.errorMessage = 'File size should be less than 3 MB.';
      return;
    }

    this.file = file;
    this.imageurl = URL.createObjectURL(file);
  }
   onCountryChange() {
    const country = 'India';
    // const selectedCountry = this.countries.find(c => c.name === country);
    // this.states = selectedCountry ? selectedCountry.states : [];
      this.apiService.getstates().subscribe({
      next: (res) => {
        this.states = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });
    this.cities = [];
    this.form.patchValue({ state: '', city: '' });
  }

  onStateChange() {
    const state = this.form.value.state;
    // const selectedState = this.states.find(s => s.name === state);
    // this.cities = selectedState ? selectedState.cities : [];
      this.apiService.getdistricts(state).subscribe({
      next: (res) => {
        this.cities = res;
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });
       if (this.personnel_id) {
      this.form.patchValue({ city: this.form.value.city });

    } else {
      this.form.patchValue({ city: '' });

    }
  }
  uploadImgAPI(callback?: () => void) {
    if (!this.file) {
      callback?.(); // continue if no file to upload
      return;
    }
  }

  onSubmit(): void {
    this.submitted = true;
    this.form.markAllAsTouched();

    if (!this.branchShow) {
      const branchCtrl = this.form.get('branch_id');
      if (branchCtrl && (branchCtrl.value == null || branchCtrl.value === '')) {
        branchCtrl.setValue(this.organizationId);
      }
    }

    if (this.form.invalid) {
      this.toastrMsgService.error('Please fill all required fields');
      return;
    }

    const formData = { ...this.form.value };
    if (formData.branch_id == null || formData.branch_id === '') {
      formData.branch_id = this.organizationId;
    }
    formData.employmentStartDate = this.toIsoDate(formData.employmentStartDate) || formData.employmentStartDate;
    formData.membershipStartDate =
      this.toIsoDate(formData.membershipStartDate) ||
      this.toIsoDate(formData.employmentStartDate) ||
      this.toIsoDate(new Date());
    formData.membershipEndDate = this.toIsoDate(formData.membershipEndDate) || formData.membershipEndDate || null;
    if (this.isEditMode) {
      this.apiService.updateStaff(this.personnel_id, formData).subscribe({
        next: (res) => {
          this.toastrMsgService.success('Staff updated successfully');
          this.router.navigate(['home/employees']);

        },
        error: (err) => {
          this.toastrMsgService.error(err.error?.errorMessage || 'Update failed');
        }
      });
    } else {
      this.apiService.saveStaff(formData).subscribe({
        next: (res: any) => {
          // Check if payment is required
          if (res.requiresPayment) {
            const amount = res.amount || 0;
            const message = res.paymentPrompt || res.message || `Subscription limit exceeded. Please pay ₹${amount} to activate this staff member.`;
            
            // Show warning message
            this.toastrMsgService.warning(message);
            
            // Prompt admin to pay
            const confirmPayment = confirm(
              `${message}\n\nWould you like to proceed to payment now?`
            );
            
            if (confirmPayment && res.subscription) {
              // Navigate to payment/subscription page with subscription ID
              this.router.navigate(['/home/subscription'], {
                queryParams: {
                  subscriptionId: res.subscription.id,
                  amount: amount,
                  type: 'staff_payment'
                }
              });
            } else {
              // Staff created but inactive, navigate to staff list
              this.toastrMsgService.info('Staff member created but inactive. Please complete payment to activate.');
              this.router.navigate(['home/employees']);
            }
          } else {
            this.toastrMsgService.success('Staff added successfully');
            this.router.navigate(['home/employees']);
          }
        },
        error: (err) => {
          this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Save failed');
        }
      });
    }

  }

  fetchStaff() {
    const params = { keyword: this.searchKeyword || '' };
    this.apiService.getStaff(params).subscribe({
      next: (res: any) => {
        const data = res.data.find((item: any) => item.id == this.personnel_id);
        if (!data) {
          return;
        }
        this.form.patchValue({
          ...data,
          branch_id: data.branch_id ?? this.form.value.branch_id ?? this.organizationId,
          domain: data.domain ?? '',
          image: data.image || '',
          emailId: data.contact_email || '',
          contact_email: data.contact_email || '',
          employeeNumber: data.employee_number,
          employmentStartDate: data.employment_start_date || null,
          postalCode: data.postal_code || '',
          roleInSoftware: data.role_in_software || '',
          specialization: data.specialization || '',
          membershipStartDate: data.membership_start_date || null,
          membershipEndDate: data.membership_end_date || null,
          city: data.city || '',
          roleId: data.role_id || '',
          employeeId: data.id || '',
          emergencyContact: {
            name: data.emergency_contact?.name || '',
            mobile: data.emergency_contact?.mobile || '',
            email: data.emergency_contact?.email || ''
          }
        });
        this.onRoleChange(data.role_id)
        this.onStateChange();

      },
      error: (err) => {
        this.toastrMsgService.error(err.error?.errorMessage || 'Failed to fetch staff');
      },
    });
  }

  saveProfile() {
    this.uploadImgAPI(() => {
      this.toastrMsgService.success('File Image Successfully Uploaded');
    });
  }
 fetchDataRole(){
       this.apiService.getAllRoles().subscribe({
      next: (res: any) => {
        console.log('Roles fetched successfully:', res);
        // Ensure res is an array before assigning to dataSource
        this.roles = res;
      },
      error: (err) => {
        console.error('Error occurred:', err);
      },
      complete: () => {
        console.log('Role fetch observable completed');
      }
    });
  }
  onRoleChange(selectedOrg: string): void {
  console.log(selectedOrg)
    this.designationList = this.organizationDesignations[selectedOrg] || [];
    // this.form.patchValue({ specialization: '' }); 
  }

  private toIsoDate(value: unknown): string | null {
    if (value == null || value === '') {
      return null;
    }
    const date = value instanceof Date ? value : new Date(String(value));
    if (Number.isNaN(date.getTime())) {
      return null;
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

}